<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
			<el-form-item label="标题:" prop="title">
				<el-input size="small" v-model="ruleForm.title"></el-input>
			</el-form-item>
			
			<el-form-item label="图片:" prop="cover_img">
				<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.cover_img" :src="ruleForm.cover_img" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			
			<el-form-item label="公告:" prop="content" style="min-height: 300px;">
				<quill-editor v-model="ruleForm.content" :options="editorOption"></quill-editor>
			</el-form-item>
			
			
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">立即添加</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				editorOption: {
					placeholder: '请输入内容...',
					theme: 'snow', // 可选：'snow'（默认）, 'bubble'
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'], // 加粗、斜体、下划线、删除线
							['blockquote', 'code-block'],
							[{ header: 1 }, { header: 2 }],
							[{ list: 'ordered' }, { list: 'bullet' }],
				
							[{ indent: '-1' }, { indent: '+1' }],
							[{ direction: 'rtl' }],
							[{ size: ['small', false, 'large', 'huge'] }],
					
							[{ color: [] }, { background: [] }],
				
							[{ align: [] }],
							['clean'], // 清除格式
							['link', 'image'] // 插入链接、图片、视频
						]
					}
				},
				ruleForm: {
					title:'',
					content:'',
					cover_img:''
				},
				rules: {
					title: [{required: true, message: '请输入标题', trigger: 'blur'}],
					content: [{required: true, message: '请输入公告内容', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.ruleForm.cover_img = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Set/addNotice", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 180px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
		border:dashed 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 180px;
	    height: 90px;
	    display: block;
	  }
</style>